import TemplateContents from './TemplateContents';
// import TopHero from './TopHero';

export default class extends TemplateContents {
  constructor(param) {
    super(param);
  }

  init() {
    super.init();

    // this.hero = new TopHero();
    // this.pack.common.addScrollTarget(this);
    this.pack.common.addEnterframeTarget(this);
  }

  reset() {
    super.reset();

    this.setVars();
    // this.pack.common.addScrollTarget(this);
    this.pack.common.addEnterframeTarget(this);
  }

  destruct() {
    super.destruct();

    // this.pack.common.removeScrollTarget(this);
    this.pack.common.removeEnterframeTarget(this);

    if (this.heroScrollBtn) {
      this.heroScrollBtn.removeEventListener(
        'click',
        this.bindHeroScrollClickHandler
      );
    }

    if (this.compoundsObserver) {
      this.compoundsObserver.disconnect();
    }

    this.compoundsNaviBtns.forEach((btn, i) => {
      btn.removeEventListener('click', this.bindCompoundsNaviClickHandlers[i]);
    });

    if (this.compoundsList) {
      this.compoundsList.removeEventListener(
        'pointerdown',
        this.bindCompoundsPointerDownHandler
      );
      this.compoundsList.removeEventListener(
        'pointermove',
        this.bindCompoundsPointerMoveHandler
      );
      this.compoundsList.removeEventListener(
        'pointerup',
        this.bindCompoundsPointerUpHandler
      );
      this.compoundsList.removeEventListener(
        'pointercancel',
        this.bindCompoundsPointerUpHandler
      );
    }

    if (this.compoundsScrollRafId) {
      cancelAnimationFrame(this.compoundsScrollRafId);
    }

    if (this.sustainCtaBtn) {
      this.sustainCtaBtn.removeEventListener(
        'pointerenter',
        this.bindSustainCtaBtnEnterHandler
      );
    }

    if (this.featureCardStalkers) {
      this.featureCardStalkers.forEach((state) => {
        state.card.removeEventListener('mousemove', state.bindMoveHandler);
        state.card.removeEventListener('mouseleave', state.bindLeaveHandler);
      });
    }

    if (this.featureCardRafId) {
      cancelAnimationFrame(this.featureCardRafId);
    }

    if (this.enjoyItemHandlers) {
      this.enjoyItemHandlers.forEach(
        ({ item, enterHandler, moveHandler, leaveHandler }) => {
          item.removeEventListener('mouseenter', enterHandler);
          item.removeEventListener('mousemove', moveHandler);
          item.removeEventListener('mouseleave', leaveHandler);
        }
      );
    }
  }

  setVars() {
    super.setVars();
  }

  setDom() {
    super.setDom();

    this.heroScrollBtn = document.querySelector('.hero__scroll');
    this.compoundsList = document.querySelector('.sectionCompounds__list');
    this.compoundsItems = document.querySelectorAll('.sectionCompounds__item');
    this.compoundsNaviTtl = document.querySelector('.sectionCompounds__naviTtl');
    this.compoundsNaviBtns = document.querySelectorAll(
      '.sectionCompounds__naviBtn'
    );
    this.sustainCtaBtn = document.querySelector('.sectionSustainCta__btn');
    this.featureCards = document.querySelectorAll('.sectionFeature__card');
    this.enjoyInner = document.querySelector('.sectionEnjoy__inner');
    this.enjoyCard = document.querySelector('.sectionEnjoy__card');
    this.enjoyItems = document.querySelectorAll('.sectionEnjoy__item');
  }

  initEvents() {
    super.initEvents();

    if (this.heroScrollBtn) {
      this.bindHeroScrollClickHandler = this.heroScrollClickHandler.bind(this);
      this.heroScrollBtn.addEventListener(
        'click',
        this.bindHeroScrollClickHandler
      );
    }

    if (this.compoundsList && this.compoundsItems.length) {
      // SP swipeable carousel — track whichever item is currently snapped
      // into view and reflect its name in &__naviTtl (see .sectionCompounds
      // __list's scroll-snap in top.scss; PC shows both items at once, so
      // this observer runs harmlessly there too since &__navi stays hidden).
      this.compoundsCurrentIndex = 0;
      this.bindCompoundsIntersectHandler =
        this.compoundsIntersectHandler.bind(this);
      this.compoundsObserver = new IntersectionObserver(
        this.bindCompoundsIntersectHandler,
        { root: this.compoundsList, threshold: 0.5 }
      );
      this.compoundsItems.forEach((item) =>
        this.compoundsObserver.observe(item)
      );

      this.bindCompoundsNaviClickHandlers = [
        () => this.compoundsNaviClickHandler(-1),
        () => this.compoundsNaviClickHandler(1),
      ];
      this.compoundsNaviBtns.forEach((btn, i) => {
        btn.addEventListener('click', this.bindCompoundsNaviClickHandlers[i]);
      });

      // Custom drag replaces native scroll-snap touch physics so the swipe
      // and the arrow buttons share the same eased snap (see
      // compoundsAnimateScrollTo) instead of the OS's own momentum curve.
      this.compoundsDrag = { active: false, startX: 0, startScrollLeft: 0 };
      this.bindCompoundsPointerDownHandler =
        this.compoundsPointerDownHandler.bind(this);
      this.bindCompoundsPointerMoveHandler =
        this.compoundsPointerMoveHandler.bind(this);
      this.bindCompoundsPointerUpHandler =
        this.compoundsPointerUpHandler.bind(this);
      this.compoundsList.addEventListener(
        'pointerdown',
        this.bindCompoundsPointerDownHandler
      );
      this.compoundsList.addEventListener(
        'pointermove',
        this.bindCompoundsPointerMoveHandler
      );
      this.compoundsList.addEventListener(
        'pointerup',
        this.bindCompoundsPointerUpHandler
      );
      this.compoundsList.addEventListener(
        'pointercancel',
        this.bindCompoundsPointerUpHandler
      );
    }

    if (this.sustainCtaBtn) {
      this.bindSustainCtaBtnEnterHandler = (event) =>
        this.circleRevealBtnEnterHandler(this.sustainCtaBtn, event);
      this.sustainCtaBtn.addEventListener(
        'pointerenter',
        this.bindSustainCtaBtnEnterHandler
      );
    }

    if (this.featureCards.length) {
      // Lerp toward the cursor every rAF frame instead of CSS-transitioning
      // top/left on each mousemove — the latter restarts mid-flight on
      // every event and looks jerky. One shared loop drives every card's
      // stalker; a card the cursor never entered just sits at (0, 0) doing
      // no visible work.
      this.featureCardStalkers = Array.from(this.featureCards)
        .map((card) => {
          // &__stalker lives outside &__card now (a sibling in &__item) so
          // it isn't clipped by the card's own overflow:hidden.
          const stalker = card.parentElement.querySelector(
            '.sectionFeature__stalker'
          );
          if (!stalker) return null;

          return {
            card,
            item: card.parentElement,
            stalker,
            targetX: 0,
            targetY: 0,
            x: 0,
            y: 0,
            targetScale: 1,
            scale: 1,
            targetRotateX: 0,
            rotateX: 0,
            targetRotateY: 0,
            rotateY: 0,
          };
        })
        .filter(Boolean);

      this.featureCardStalkers.forEach((state) => {
        state.bindMoveHandler = (event) => {
          // Measure against &__item, not &__card itself — the card gets a
          // live scale/tilt transform each frame (below), which skews its
          // own getBoundingClientRect() away from the static layout box that
          // &__stalker (a sibling, untransformed) is actually positioned in.
          const rect = state.item.getBoundingClientRect();
          state.targetX = event.clientX - rect.left;
          state.targetY = event.clientY - rect.top;

          // -0.5..0.5 across the card, used to drive a subtle 3D tilt
          // (feature-card-max-tilt below caps how far it can lean).
          const px = state.targetX / rect.width - 0.5;
          const py = state.targetY / rect.height - 0.5;
          const maxTilt = 3;
          state.targetRotateY = px * maxTilt * 2;
          state.targetRotateX = -py * maxTilt * 2;
          state.targetScale = 1.08;
        };
        state.bindLeaveHandler = () => {
          state.targetRotateX = 0;
          state.targetRotateY = 0;
          state.targetScale = 1;
        };
        state.card.addEventListener('mousemove', state.bindMoveHandler);
        state.card.addEventListener('mouseleave', state.bindLeaveHandler);
      });

      this.bindFeatureCardTick = this.featureCardTick.bind(this);
      this.featureCardRafId = requestAnimationFrame(this.bindFeatureCardTick);
    }

    this.initEnjoyCardHover();
  }

  start() {
    trace('Top Start');
  }

  heroScrollClickHandler() {
    this.pack.anchorScroll(this.sh);
  }

  compoundsIntersectHandler(entries) {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;

      const index = Array.from(this.compoundsItems).indexOf(entry.target);
      this.compoundsCurrentIndex = index;
      this.compoundsNaviTtl.textContent = entry.target.dataset.name;
    });
  }

  compoundsNaviClickHandler(dir) {
    const nextIndex = Math.min(
      Math.max(this.compoundsCurrentIndex + dir, 0),
      this.compoundsItems.length - 1
    );

    this.compoundsScrollToIndex(nextIndex);
  }

  compoundsPointerDownHandler(event) {
    this.compoundsDrag.active = true;
    this.compoundsDrag.startX = event.clientX;
    this.compoundsDrag.startScrollLeft = this.compoundsList.scrollLeft;
    this.compoundsList.setPointerCapture(event.pointerId);

    if (this.compoundsScrollRafId) {
      cancelAnimationFrame(this.compoundsScrollRafId);
      this.compoundsScrollRafId = null;
    }
  }

  compoundsPointerMoveHandler(event) {
    if (!this.compoundsDrag.active) return;

    const dx = event.clientX - this.compoundsDrag.startX;
    this.compoundsList.scrollLeft = this.compoundsDrag.startScrollLeft - dx;
  }

  compoundsPointerUpHandler(event) {
    if (!this.compoundsDrag.active) return;

    this.compoundsDrag.active = false;
    this.compoundsList.releasePointerCapture(event.pointerId);

    const itemWidth = this.compoundsItems[0].offsetWidth;
    const nextIndex = Math.min(
      Math.max(Math.round(this.compoundsList.scrollLeft / itemWidth), 0),
      this.compoundsItems.length - 1
    );

    this.compoundsScrollToIndex(nextIndex);
  }

  compoundsScrollToIndex(index) {
    this.compoundsCurrentIndex = index;
    this.compoundsNaviTtl.textContent = this.compoundsItems[index].dataset.name;
    this.compoundsAnimateScrollTo(this.compoundsItems[index].offsetLeft, 500);
  }

  // easeInOutCubic, matching $easeInOutCubic's feel for a manually driven
  // scrollLeft — scrollIntoView/scrollTo's "smooth" option only exposes the
  // browser's own fixed timing function, not a custom curve.
  compoundsAnimateScrollTo(target, duration) {
    const list = this.compoundsList;
    const start = list.scrollLeft;
    const distance = target - start;
    const startTime = performance.now();
    const easeInOutCubic = (t) =>
      t < 0.5 ? 4 * t * t * t : 1 - (-2 * t + 2) ** 3 / 2;

    const step = (now) => {
      const t = Math.min((now - startTime) / duration, 1);
      list.scrollLeft = start + distance * easeInOutCubic(t);

      if (t < 1) {
        this.compoundsScrollRafId = requestAnimationFrame(step);
      } else {
        this.compoundsScrollRafId = null;
      }
    };

    this.compoundsScrollRafId = requestAnimationFrame(step);
  }

  // Shared by any "circle grows from cursor" button (--hover-x/--hover-y
  // consumed by its ::before in top.scss) — .sectionSustainCta__btn uses
  // this on pointerenter.
  circleRevealBtnEnterHandler(btn, event) {
    const rect = btn.getBoundingClientRect();
    const x = ((event.clientX - rect.left) / rect.width) * 100;
    const y = ((event.clientY - rect.top) / rect.height) * 100;

    btn.style.setProperty('--hover-x', `${x}%`);
    btn.style.setProperty('--hover-y', `${y}%`);
  }

  // .sectionEnjoy__card(ホバー時のプレビュー)を、ホバー中の.sectionEnjoy__itemの
  // 天地中央に実測で追従させ(項目ごとに高さが変わり得るのでJSで位置決めする)、
  // カーソルのX位置に応じて左右にも少しドリフトさせる。
  initEnjoyCardHover() {
    if (!this.enjoyCard || !this.enjoyInner || !this.enjoyItems.length) return;

    this.enjoyItemHandlers = Array.from(this.enjoyItems).map((item) => {
      const enterHandler = () => {
        const innerRect = this.enjoyInner.getBoundingClientRect();
        const itemRect = item.getBoundingClientRect();
        const itemCenterY = itemRect.top + itemRect.height / 2 - innerRect.top;

        this.enjoyCard.style.top = `${itemCenterY - this.enjoyCard.offsetHeight / 2}px`;
      };

      const moveHandler = (event) => {
        const rect = item.getBoundingClientRect();
        const offsetX = event.clientX - (rect.left + rect.width / 2);

        this.enjoyCard.style.transform = `translateX(${offsetX * 0.18}px)`;
      };

      const leaveHandler = () => {
        this.enjoyCard.style.transform = '';
      };

      item.addEventListener('mouseenter', enterHandler);
      item.addEventListener('mousemove', moveHandler);
      item.addEventListener('mouseleave', leaveHandler);

      return { item, enterHandler, moveHandler, leaveHandler };
    });
  }

  featureCardTick() {
    this.featureCardStalkers.forEach((state) => {
      state.x += (state.targetX - state.x) * 0.15;
      state.y += (state.targetY - state.y) * 0.15;
      state.stalker.style.transform = `translate(${state.x}px, ${state.y}px)`;

      state.scale += (state.targetScale - state.scale) * 0.12;
      state.rotateX += (state.targetRotateX - state.rotateX) * 0.12;
      state.rotateY += (state.targetRotateY - state.rotateY) * 0.12;
      state.card.style.transform = `perspective(80rem) scale(${state.scale}) rotateX(${state.rotateX}deg) rotateY(${state.rotateY}deg)`;
    });

    this.featureCardRafId = requestAnimationFrame(this.bindFeatureCardTick);
  }

  scrollHandler() {}

  enterframe() {}

  enterframeThinOut() {
    // this.hero.enterframeThinOut();
  }

  executeResize() {
    super.executeResize();
  }
}
